module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp123_1.8d42b609.png";